<template>
    <div>
        <div v-if="data === undefined || data.length=== 0" class="d-flex justify-content-center text-invalid mb-2"
        >{{$t('COMMON.NO_DATA')}}
        </div>
        <div v-else>
            <el-table
                    :data="filteredData"
                    style="width: 100%" class="mb-2"
                    header-cell-class-name="text-dark bg"
                    v-on:filter-change="OnFilterChange" 
                    @row-dblclick="goToLastData"      
                    :default-sort = "{prop: 'date', order: 'descending'}"             
                    :row-class-name="tableRowClassName"
            >
                <el-table-column class-name="pl-3" width="60" label="#" sortable>
                    <template slot-scope="scope">
                        {{data.indexOf(scope.row) +1}}
                    </template>
                </el-table-column>
                <!-- :label="$tc('COMMON.SITE',1)" -->
                <el-table-column
                        prop="siteName"
                        :label="$tc('COMMON.SITE',1)"
                        :filters="possibleSiteFilters"
                        filter-multiple
                        column-key="siteName"
                        min-width="150"
                        width="150"
                >
                    <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark"
                                    :content="$t('COMMON.CLICK_SILO')"
                                    placement="top-end">
                        <div class="d-flex  align-items-center">
                         <div>{{scope.row.siteName}}</div>
                        </div>
                    </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="name"
                        sortable
                        :label="$tc('COMMON.SILO',1)"                                                
                >
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark"
                                    :content="$t('COMMON.CLICK_SILO')"
                                    placement="top-end">
                        <div class="d-flex  align-items-center">
                         <div>{{scope.row.name}}</div>
                        </div>
                    </el-tooltip>
                </template>
                </el-table-column>

                <el-table-column
                        :label="$t('COMMON.STATUS')"
                        :filters="possibleErrorsFilters"
                        filter-multiple
                        column-key="status"
                        min-width="90" width="90"
                        >
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.status === 0" class="item" effect="dark"
                                    :content="$t('STATUS.NO_DATA')"
                                    placement="top-end">
                            <i class="el-icon-remove"/>
                        </el-tooltip>
                        <el-tooltip v-if="scope.row.status === 1" class="item" effect="dark"
                                    :content="$t('STATUS.OK')"
                                    placement="top-end">
                            <i class="el-icon-success text-success"/>
                        </el-tooltip>
                        <el-tooltip v-if="scope.row.status === 2" class="item" effect="dark"
                                    :content="$t('STATUS.WARN')"
                                    placement="top-end">
                            <i class="el-icon-warning text-warning"/>
                        </el-tooltip>
                        <el-tooltip v-if="scope.row.status === 3" class="item" effect="dark"
                                    :content="$t('STATUS.ERROR')"
                                    placement="top-end">
                            <i class="el-icon-error text-danger"/>
                        </el-tooltip>
                        <el-tooltip v-if="scope.row.status === 5" class="item" effect="dark"
                                    :content="$t('STATUS.DISABLED')"
                                    placement="top-end">
                            <i class="el-icon-error"/>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- :label="$tc('COMMON.SECTION',1)" 
                 min-width="350"
                        width="350"
                -->
                <el-table-column
                        prop="seccion"
                        :label="$t('COMMON.CO2')"      
                >
                    <template slot-scope="scope">
                        {{buildText("co2",scope.row.promdata)}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="seccion"
                        :label="$t('COMMON.MOISTABLE')"      
                >
                    <template slot-scope="scope">
                        {{buildText("moisture",scope.row.promdata)}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="seccion"
                        :label="$t('COMMON.TEMPERATURE')"      
                >
                    <template slot-scope="scope">
                         {{buildText("temp",scope.row.promdata)}}
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('COMMON.LAST_SYNC')"
                        prop="date"
                        sortable
                        :sort-method="tableDateSort"
                >
                    <template slot-scope="scope">
                         {{formatDate(scope.row.lastdata)}}
                    </template>
                    <!-- <template slot-scope="scope">
                        <div class="d-flex  align-items-center">
                            <div class="w-50">{{scope.row.date}}</div>
                            <div v-if="isOldDate(scope.row.date) && scope.row.status !== 5"
                                 class="d-flex flex-column align-items-center ">
                                <i style="font-size: 2em;" class="material-icons text-warning  ">warning</i>
                                <div>{{$t('ERROR.COMMUNICATION_FAILURE')}}</div>
                            </div>
                        </div>
                    </template>
                    -->
                </el-table-column>
                <el-table-column class-name="pl-3" label=""  >
                    <template slot-scope="scope">
                        <el-dropdown :hide-on-click="false" v-if="eventsForSilo(scope.row).length !==0">
                            <el-badge :value="eventsForSilo(scope.row).length" :max="9" class="item"
                                      :hidden="eventsForSilo(scope.row).length ===0">
                                <i class="el-icon-message-solid"/>
                            </el-badge>
                            <el-dropdown-menu slot="dropdown">
                                <div class="scrollable">

                                    <el-dropdown-item v-for="event in eventsForSilo(scope.row)" :key="event.eventid"
                                                      :label="event.type"
                                                      :value="event.eventid" :command="event"
                                                      class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex justify-content-between align-items-center w-100">
                                            <div>
                                                <div>
                                                    {{$tc('COMMON.SECTION',1)+ ': ' + event.section}}
                                                </div>
                                                <div>{{$t('EVENTS.' + event.type.toUpperCase(), {status:
                                                    getStatus(event.status)})}}
                                                </div>
                                                <div class="mt-n3 text-muted" style="font-size: 0.9em">
                                                    {{formatDateOld(event.date)}}
                                                </div>
                                                <div>
                                                    <hr>
                                                </div>
                                            </div>
                                            <el-button type="text" class="ml-4 text-right" style="font-size: 1.1em;"
                                                       icon="el-icon-delete " @click="deleteEvent(event)"/>

                                        </div>
                                    </el-dropdown-item>
                                </div>
                                <el-dropdown-item divided class="text-center">
                                    <el-button type="text" @click="deleteAllEvents(eventsForSilo(scope.row))">
                                        Elimitar todas
                                    </el-button>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    :hide-on-single-page="true"                    
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="20"
                    class="d-flex justify-content-center"
                    layout="prev, pager, next"
                    :total="paginatorLength"
                    :current-page.sync="currentPage">
            </el-pagination>
        </div>
    </div>

</template>

<script>

    import dateFormater from "../../utils/dateFormater";
    import routesNames from "../../utils/router/routesNames";
    import mutations from "../../utils/store/mutations";
    import unitConverter from "../../utils/unitConverter";

    export default {
        name: "wTableSilo",
        props: {
            data: {
                type: Array,
                required: true
            },
            events: {
                type: Array
            },
            onDeleteEvent: {
                type: Function
            }
        },
        data() {
            return {
                currentPage: 1,
                tableData: undefined,
                siteFilters: [],
                errorFilters: [],
                selectedEvents: [],
                today: new Date(),
                TWO_DAYS_IN_MILLIS: 172800000
            }
        },
        computed: {
            filteredData: function () {
                const pageSize = 20;
                this.data.sort((a, b) => {
                    return this.sortData(a, b);
                });
                return this.data
                    .filter(row => {
                        if (this.siteFilters === undefined || this.siteFilters.length === 0) {
                            return true
                        }
                        return this.siteFilters.indexOf(row.siteName) !== -1
                    }).filter(row => {
                        if (this.errorFilters === undefined || this.errorFilters.length === 0) {
                            return true
                        }
                        return this.errorFilters.indexOf(row.status) !== -1
                    }).slice((this.currentPage - 1) * pageSize, (this.currentPage) * pageSize);
            },
            possibleSiteFilters: function () {
                let sitesName = [];
                this.data.forEach(value => {
                    if (sitesName.indexOf(value.siteName) === -1) {
                        sitesName.push(value.siteName)
                    }
                });
                sitesName.sort();
                return sitesName.map(value => {
                    return {text: value, value: value}
                });
            },
            possibleErrorsFilters: function () {
                let posibleStatus = ["STATUS.NO_DATA", "STATUS.OK", "STATUS.WARN", "STATUS.ERROR", "sin uso", "STATUS.DISABLED"];
                let errorsName = [];
                this.data.forEach(value => {
                    if (value.status !== undefined && errorsName.indexOf(value.status) === -1) {
                        errorsName.push(value.status)
                    }
                });
                errorsName.sort();
                return errorsName.map(value => {
                    return {text: this.$t(posibleStatus[value]), value: value}
                });
            },
            paginatorLength: function () {
                if (this.siteFilters.length === 0 && this.errorFilters.length === 0) {
                    return this.data.length
                } else {
                    if (this.tableData === undefined) {
                        return 1
                    } else {
                        return this.tableData.length;
                    }
                }

            }
        },
        methods: {
            OnFilterChange: function (a) {
                if (a.status !== undefined) {
                    this.errorFilters = a.status;
                }
                if (a.siteName !== undefined) {
                    this.siteFilters = a.siteName;
                }
                this.tableData = this.filterData(this.siteFilters, this.errorFilters);

            },
            filterData: function (sitesFilter, errorsFilter) {
                this.data.sort((a, b) => {
                    return this.sortData(a, b);
                });
                return this.data
                    .filter(row => {
                        if (sitesFilter === undefined || sitesFilter.length === 0) {
                            return true
                        }
                        return sitesFilter.indexOf(row.siteName) !== -1
                    }).filter(row => {
                        if (errorsFilter === undefined || errorsFilter.length === 0) {
                            return true
                        }
                        return errorsFilter.indexOf(row.status) !== -1
                    });


            },
            sortData: function (a, b) {
                const bEventsLength = this.eventsForSilo(b).length;
                const aEventsLength = this.eventsForSilo(a).length;

                if (bEventsLength > 0 && aEventsLength === 0) {
                    return 1;
                } else if (bEventsLength === 0 && aEventsLength > 0) {
                    return -1;
                }

                let statusAAux = a.status === 5 ? -5 : a.status;
                let statusBAux = b.status === 5 ? -5 : b.status;

                let order = statusBAux - statusAAux;
                if (order === 0) {
                    return b.date > a.date ? 1 : -1;
                }
                return order;
            },
            tableRowClassName({row, rowIndex}) 
            {
                //console.log("ROW:", row);

                switch(row.status)
                {

                    case 2:
                    return 'warning-row';


                    case 3:
                    return 'danger-row';


                    default:
                    return '';
                }

            },
            formatDate(date) {
                //console.log("Date: ",date);
                let offset = parseInt(this.$store.state.user.timezone);
                //console.log("Offset: ",offset);
                let newDate = dateFormater.dateOffset(date, offset);
                //return dateFormater.YYYY_MM_DD_HH_MM_SS(new Date(date * 1000))
                return dateFormater.dateFormat(newDate,this.$store.state.language);
            },
            tableDateSort(a, b) {
               // Parsear las fechas a objetos Date para poder compararlas
               //console.log("Comparando fechas: ",a,b);
                const dateA = new Date(a.lastdata);
                const dateB = new Date(b.lastdata);

                //console.log("Comparando fechas: ",dateA,dateB);

                // Comparar las fechas y devolver el resultado
                if (dateA < dateB) {
                    return 0;
                }
                if (dateA > dateB) {
                    return 2;
                }
                return 1;
            },  
            formatDateOld(date) {
                let fint;
                let offset = parseInt(this.$store.state.user.timezone);
                fint = dateFormater.YYYY_MM_DD_HH_MM_SS(new Date(date * 1000));
                let newDate = dateFormater.dateOffset(fint, offset);
                return this.formatDate(newDate);
            },        
            deleteEvent(event) {
                if (this.onDeleteEvent) {
                    this.onDeleteEvent(event);
                }
            },
            deleteAllEvents(events) {
                events.forEach(event => {
                        this.deleteEvent(event)
                    }
                );
            },
            isOldDate(date) {
                return this.today.getTime() - this.TWO_DAYS_IN_MILLIS > new Date(date).getTime()
            },
            eventsForSection(section) {
                if (this.events === undefined) {
                    return []
                }
                return this.events.filter(event => {
                    return event.siteid.toString() === section.siteId.toString()
                        && event.siloid.toString() === section.siloId.toString()
                        && event.section.toString() === section.seccion.toString()

                });
            },
            eventsForSilo(silo) {
                if (this.events === undefined) {
                    return []
                }
                return this.events.filter(event => {
                    return event.siteid.toString() === silo.siteId.toString()
                        && event.siloid.toString() === silo.id.toString()

                });
            },
            getStatus(status) {
                const messages = ["", "OK",
                    "WARN",
                    "DANGER"];

                return this.$t('INDICATOR.' + messages[status]);
            },
            rowClicked(row) 
            {
                //this.$refs.tableData.toggleRowExpansion(row);
                console.log("ID de Sitio: " + row.siteId + " | ID Silo: " + row.siloId);
            },
            goToLastData(row) {
                //console.log("ID de Sitio: " + row.siteId + " | ID Silo: " + row.siloId);               
                this.$store.commit(mutations.CHANGE_SITE_SELECTED, row.siteId);
                this.$store.commit(mutations.CHANGE_SILO_SELECTED, row.id);
                //console.log("ID de Silo STORE: " + this.$store.state.siloSelected);
                //console.log("ID de Sitio STORE: " +this.$store.state.siteSelected);
                this.$router.push({name: routesNames.VIEW_ONLY_SILO});
            },
            printValues(item,values)
            {
                let row = undefined;
                switch(item)
                {
                    case "CO2":
                        row = values.CO2 + " ppm";
                    break;
                    
                    case "temp":
                        row = values.temp + " C";
                    break;

                    case "moisture":
                        row = values.hum_grano + " %";
                    break;
                    
                    default:
                    return "";

                }
                //row = "CO2:" + values.CO2 + " ppm"+" | Temp:"+values.temp+" C"+" | " + "Moist: "+values.hum_grano+" %";
                return row;
            },
            convertIndex(type,values)
            {
                 let indice;
                //Rebautizamos los tipos para no cambiar todo
                switch(type)
                {
                    case "temp":
                        indice = values.temp;
                    break;

                    case "hum":
                        indice = 0;
                    break;

                    case "co2":
                        indice = values.co2;
                    break;
                    
                    case "moisture":
                        indice = values.moisture;
                    break;

                    default: //Tipo invalido, retornamos no data
                    return false;
                }
                return indice;
            },
            /*buildText(type, value) {
                if (value && value.length > 0 && value[value.length - 1]) {
                    return unitConverter.convertTo(type, value[value.length - 1][type], this.$store.getters.unit(type)) + " " + this.$store.getters.unit(type);
                } else {
                    return this.$t("REPORTS.NO_DATA");
                }
            },
            */
            buildText(type,row)
            {
                let value;
                value = this.convertIndex(type,row);

                if(!value)
                {
                    return this.$t("REPORTS.NO_DATA");
                }
                if(isNaN(value))
                {
                    return "-";                    
                }

                //console.log("Value "+value);
                return unitConverter.convertTo(type,value, this.$store.getters.unit(type)) + " " + this.$store.getters.unit(type);
               

            }

        }

    }
</script>

<style lang="scss">
    .scrollable {
        max-height: 250px;
        overflow: auto;


        &::-webkit-scrollbar {
            width: 3px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px #fafafa;
            border-radius: 10px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
            background: gray;
            border-radius: 10px;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
            background: #fafafa;
        }
    }

    .el-badge__content.is-fixed {
        position: absolute;
        top: 5px;
        right: 6px;
    }

    .el-table .warning-row {
    background: rgb(252, 245, 196);
  }
  .el-table .danger-row {
    background: rgb(252, 217, 217);
  }
</style>